import(/* webpackMode: "eager" */ "/home/runner/work/brics-website/brics-website/app/[locale]/mass-media/page.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["MediaAboutFeed"] */ "/home/runner/work/brics-website/brics-website/sections/media-about-feed/media-about-feed.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderPage"] */ "/home/runner/work/brics-website/brics-website/shared/ui/header-page/header-page.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/brics-website/brics-website/shared/utils/common.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/brics-website/brics-website/shared/utils/hooks.tsx");
